import { registerTool } from '../ToolRegistry'
import { getSharedToolRegistration } from '../sharedToolCatalog'
import { useDiceRollerStore } from '@/stores/diceRollerStore'
import { useCharacterStore } from '@/stores/characterStore'

export function registerDiceTools() {
  registerTool({
    ...getSharedToolRegistration('open_dice_roller'),
    handler: async (args) => {
      try {
        const diceStore = useDiceRollerStore()
        diceStore.showDiceRoller({
          characterId: args?.characterId ? String(args.characterId) : undefined,
          campaignId: args?.campaignId ? String(args.campaignId) : undefined,
          sessionId: args?.sessionId ? String(args.sessionId) : undefined
        })
        return { ok: true, opened: true, message: 'Dice roller opened' }
      } catch (e) {
        return { ok: false, error: e?.message || 'Failed to open dice roller' }
      }
    }
  })

  registerTool({
    ...getSharedToolRegistration('roll_dice'),
    handler: async (args) => {
      const formula = String(args?.formula || '').trim()
      if (!formula) {
        return { ok: false, error: 'dice_formula_required' }
      }
      const note = args?.note ? String(args.note) : undefined
      const cs = useCharacterStore()
      const currentChar =
        (typeof cs?.getCurrentCharacter === 'function'
          ? cs.getCurrentCharacter()
          : cs?.currentCharacter) || null
      const fallbackCharId = currentChar && (currentChar.id || currentChar.value?.id)
      const singleCharId =
        !args?.characterId && Array.isArray(cs?.characters) && cs.characters.length === 1
          ? cs.characters[0]?.id
          : null
      const characterId = args?.characterId
        ? String(args.characterId)
        : fallbackCharId || singleCharId || null

      const diceStore = useDiceRollerStore()
      try {
        const result = await diceStore.quickRoll(formula, {
          note,
          showOverlay: false,
          characterId,
          rollSource: 'ai_tool',
          rollContext: characterId ? 'character' : 'general'
        })
        const total = result?.total ?? null
        const rolls = Array.isArray(result?.rawResults) ? result.rawResults : []
        return {
          ok: true,
          message:
            total !== null
              ? `Rolled ${formula}${note ? ` — ${note}` : ''}: total ${total}`
              : `Rolled ${formula}${note ? ` — ${note}` : ''}`,
          total,
          rolls,
          characterId
        }
      } catch (e) {
        return { ok: false, error: e?.message || 'Failed to roll dice' }
      }
    }
  })
}
